module.exports = __webpack_public_path__ + "static/media/personal-loan.2e452998.jpg";